import React from "react";
import { Navigate } from "react-router-dom";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

//Screens
import Home from "./Screens/Home/Home";
import Login from "./Screens/Login/Login";
import Invitation from "./Screens/Signup/Invitation";
import SetupProfile from "./Screens/Signup/SetupProfile";
import Otp from "./Screens/Signup/Otp";
import ValidateUsername from "./Screens/Signup/ValidateUsername";
import MyInformation from "./Screens/Profile/MyInformation";
import Overview from "./Screens/Profile/Overview/Overview";
import Policies from "./Screens/Profile/Policies/Policies";
import Household from "./Screens/Profile/Houshold/Household";
import Accounts from "./Screens/Profile/WMAccount/Accounts";
import SpousePolicies from "./Screens/Profile/Policies/SpousePolicies";
import SpouseWMAccounts from "./Screens/Profile/WMAccount/SpouseWMAccounts";
import NotFound from "./NotFound";
import DocumentValut from "./Screens/Profile/documentVault/documentValut";
import ChangePassword from "./Screens/Profile/ChangePassword";
import Aboutus from "./Screens/Profile/Aboutus";
import FAQ from "./Screens/Profile/FAQ";
import ForgetPassword from "./Screens/Signup/ForgetPassword";
import FirstMeeting from "./Screens/FirstMeeting/FirstMeeting";
import Submitted from "./Screens/FirstMeeting/Submitted";
import Qualified from "./Screens/FirstMeeting/Qualified";
function Router() {
  const basename = process.env.REACT_APP_BASENAME || '';

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
      errorElement: <NotFound />,
    },
    {
      path: "/Login",
      element: <Login />,
      errorElement: <NotFound />,
    },
    {
      path: "/Invitation/:id",
      element: <Invitation />,
      errorElement: <NotFound />,
    },
    {
      path: "/Invitation/",
      element: <Invitation />,
      errorElement: <NotFound />,
    },
    {
      path: "/SetupProfile",
      element: <SetupProfile />,
      errorElement: <NotFound />,
    },
    {
      path: "/MyInformation",
      element: <MyInformation />,
      errorElement: <NotFound />,
    },

    {
      path: "/Otp",
      element: <Otp />,
      errorElement: <NotFound />,
    },
    {
      path: "/ValidateUsername",
      element: <ValidateUsername />,
      errorElement: <NotFound />,
    },
    {
      path: "/Overview",
      element: <Overview />,
      errorElement: <NotFound />,
    },
    {
      path: "/Policies",
      element: <Policies />,
      errorElement: <NotFound />,
    },
    {
      path: "/spouse-policies",
      element: <SpousePolicies />,
      errorElement: <NotFound />,
    },
    {
      path: "/Household",
      element: <Household />,
      errorElement: <NotFound />,
    },
    {
      path: "/spouse-WMAccounts",
      element: <SpouseWMAccounts />,
      errorElement: <NotFound />,
    },
    {
      path: "/WMAccounts",
      element: <Accounts />,
      errorElement: <NotFound />,
    },
    {
      path: "/DocumentValut",
      element: <DocumentValut />,
      errorElement: <NotFound />,
    },
    {
      path: "/Security",
      element: <ChangePassword />,
      errorElement: <NotFound />,
    },
    {
      path: "/Aboutus",
      element: <Aboutus />,
      errorElement: <NotFound />,
    },
    {
      path: "/FAQ",
      element: <FAQ />,
      errorElement: <NotFound />,
    },
    {
      path: "/ForgetPassword",
      element: <ForgetPassword />,
      errorElement: <NotFound />,
    },
    {
      path: "/FirstMeeting/:leadid",
      element: <FirstMeeting />,
      errorElement: <NotFound />,
    },
    {
      path: "/Submitted/",
      element: <Submitted />,
      errorElement: <NotFound />,
    },
    {
      path: "/Qualified/",
      element: <Qualified />,
      errorElement: <NotFound />,
    },

    {
      path: "*",
      element: <Navigate to="/" replace />,
    }

  ]);

  return (
    <RouterProvider
      basename={basename}
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
}

export default Router;
